import { TFactoryState } from '@monorepo/types';
import { Action } from '@ngrx/store/src/models';

export class InitializeFactory implements Action {
  readonly type = 'INITIALIZE_FACTORY' as const;
  constructor(public payload: TFactoryState['factoryInfo']) {}
}

export class SelectOrgTreeNode implements Action {
  readonly type = 'SELECT_ORG_TREE_NODE' as const;
  constructor(public payload: TFactoryState['selectedNodeInfo']) {}
}

export class OrgTreeNodeLoading implements Action {
  readonly type = 'ORG_TREE_NODE_LOADING' as const;
  constructor(public title: string) {}
}

export class OrgTreeNodeLoaded implements Action {
  readonly type = 'ORG_TREE_NODE_LOADED' as const;
  constructor() {}
}

export type TFactoryActions = InitializeFactory | SelectOrgTreeNode | OrgTreeNodeLoading | OrgTreeNodeLoaded;
